export const STEPS = {
  INPUT_DOMAIN: 'inputDomain',
  DOMAIN_NOT_REGISTERED: 'domainNotRegistered', // domain_not_available
  DOMAIN_EXIST_INTERNAL: 'domainExistInternal', // domain_ok
  DOMAIN_EXIST_EXTERNAL: 'domainExistExternal', // domain_another_provider
  DOMAIN_NOT_AVAILABLE_IN_TITAN: 'domainNotAvailableInTitan', // titan_not_available
  FLOW_FINISHED_BUYING_DOMAIN: 'flowFinishedBuyingDomain',
  CHANGED_INTERNAL_TITAN_DOMAIN: 'changedInternalTitanDomain',
  CHANGE_DOMAIN_FAILED: 'changeDomainFailed',
};

export const AVAILABILITY_STATUS = {
  DOMAIN_OK: 'domain_ok',
  DOMAIN_ANOTHER_PROVIDER: 'domain_another_provider',
  TITAN_NOT_AVAILABLE: 'titan_not_available',
  DOMAIN_NOT_AVAILABLE: 'domain_not_available',
};
